export const isDate = (value) => value instanceof Date;

export const modifyDate = (date, components = {}, resetTime = true) => {
    if(isDate(date)){
        date = new Date(date);
        if(Object.keys(components).length){
            for(let key in components){
                date[`set${key.slice(0,1).toUpperCase()}${key.slice(1)}`](parseInt(components[key], 10));
            }
        }
        if(resetTime){
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
    }
    return date;
};

export const durationToMS = (ISODuration) => {
    if(typeof ISODuration !== 'string'){
        return ISODuration;
    }

    // pattern to match ISO 8601 Durations
    // https://en.wikipedia.org/wiki/ISO_8601#Durations
    // in the spec the order of designators doesnt' matter except for the `T` designator
    // in this implementation designators should come in order from large (`Y`) to small (`S`)
    const pattern = /^P(?!$)(((\d+)Y)?((\d+)M)?((\d+)D)?(T((\d+)H)?((\d+)M)?((\d+)S)?)?)$/;

    const matches = ISODuration.match(pattern);

    const diff = {
        years: parseInt(matches[3], 10) || 0,
        months: parseInt(matches[5], 10) || 0,
        days: parseInt(matches[7], 10) || 0,
        hours: parseInt(matches[10], 10) || 0,
        minutes: parseInt(matches[12], 10) || 0,
        seconds: parseInt(matches[14], 10) || 0
    };

    const compareDate = new Date();
    compareDate.setMilliseconds(0);
    const newDate = new Date(
        compareDate.getFullYear() + diff.years,
        compareDate.getMonth() + diff.months,
        compareDate.getDate() + diff.days,
        compareDate.getHours() + diff.hours,
        compareDate.getMinutes() + diff.minutes,
        compareDate.getSeconds() + diff.seconds,
        0
    );

    return (newDate - compareDate);
};

export const unsetTime = (date) => modifyDate(date, {hours: 0, minutes: 0});



// WEBPACK FOOTER //
// ./src/components/UI/DateTimePicker/DateTimeHelpers.js